// JsFromRoutes CacheKey 2d90a723ab543e3f830224b1775a3f1c
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  destroy: /* #__PURE__ */ definePathHelper('delete', '/testing_tools/nps/test_survey'),
  create: /* #__PURE__ */ definePathHelper('post', '/testing_tools/nps/test_survey'),
}
